import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { IonCol, IonRow } from "@ionic/vue";
import { computed, ref, watch } from "vue";

import ButtonBase from "@/components/button/ButtonBase.vue";
import SelectSimple from "@/components/selects/SelectSimple.vue";
import InputAmountPerformanceNewWeb from "@/components/input/InputAmountPerformanceNewWeb.vue";

import { ION_VARIANT } from "@/types/enum/ionicEnum";
import { FlexibleProductInterfaceProps } from "@/types/props/component";
import { FlexibleProductInterfaceEmits } from "@/types/emits/component";


export default /*@__PURE__*/_defineComponent({
  __name: 'FlexibleProductInterface',
  props: {
    information: {},
    audience: {}
  },
  emits: ["addPackage"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const products = ref<Record<string, number>>({})
const selectedSupplierId = ref<string>(props.audience[0].id)

const availableProducts = computed(() => {
    const matchedProducts = []
    for (const product of props.information.products) {
        if (product.availableBy?.length && product.availableBy.includes(selectedSupplierId.value)) matchedProducts.push(product)
    }
    // if (!matchedProducts.length) return props.information.products // If non-harmonised products are allowed
    return matchedProducts
})

const changeSupplierId = (supplierId: unknown) => {
    if (typeof supplierId === "string") selectedSupplierId.value = supplierId
}

watch(selectedSupplierId, () => products.value = {}) // reset values if supplier change

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonRow), { class: "mt-2" }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonCol), { class: "fs-smaller fs-12 grey1-grey1-color" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t(`alert.selectSupplier`)), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(IonRow), { class: "supplier-name-bold mb-2" }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonCol), null, {
          default: _withCtx(() => [
            _createVNode(SelectSimple, {
              "model-value": selectedSupplierId.value,
              onChange: changeSupplierId,
              class: "grey4-grey4-background inherit-background purple-purple-color max-width chevron-select unset-max-width",
              placeholder: _ctx.$t('messages.setting.delivererSelect'),
              options: (__props.audience as unknown as { [key: string]: unknown }[]),
              valueKey: "id",
              textKey: "name",
              disabled: __props.audience.length < 1
            }, null, 8, ["model-value", "placeholder", "options", "disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(IonRow), null, {
      default: _withCtx(() => [
        (availableProducts.value.length)
          ? (_openBlock(), _createBlock(_unref(IonCol), { key: 0 }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableProducts.value, (product) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: product.id,
                    class: "item-container"
                  }, [
                    _createElementVNode("div", null, _toDisplayString(product.item.name) + " " + _toDisplayString(product.item.variants.name), 1),
                    _createVNode(InputAmountPerformanceNewWeb, {
                      style: {"transform":"scale(0.9)","margin":"0"},
                      modelValue: products.value[product.id],
                      "onUpdate:modelValue": ($event: any) => ((products.value[product.id]) = $event),
                      onChange: ($event: any) => {products.value[product.id] = $event;},
                      "amount-step": product.stepAmount,
                      max: product.limitOrderSize
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "amount-step", "max"])
                  ]))
                }), 128))
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_unref(IonCol), { key: 1 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('messages.noEntries')), 1)
              ]),
              _: 1
            }))
      ]),
      _: 1
    }),
    (availableProducts.value.length)
      ? (_openBlock(), _createBlock(_unref(IonRow), { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCol), { class: "center" }, {
              default: _withCtx(() => [
                _createVNode(ButtonBase, {
                  color: _unref(ION_VARIANT).CORAL,
                  class: "ml-3 mr-3 fw-b wrap-button tt-none max-width",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('addPackage', { products: products.value, supplierId: selectedSupplierId.value}))),
                  disabled: Object.values(products.value).reduce((a, v) => a + v, 0) < Number(__props.information.config?.packageSize)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(`modal.addCart`)), 1)
                  ]),
                  _: 1
                }, 8, ["color", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})